import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import BackpackLayers from '../game/BackpackLayers';
import gameData from '../gameData';
import { playGameJingle } from '../JingleController';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import MakeScene from './MakeScene';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import FontKeys from '../FontKeys';

export default class Title extends Phaser.Scene
{
    static get KEY() { return 'Title'; }

    constructor()
    {
        super({ key: (Title).KEY });
    }

    create()
    {
        playGameJingle();

        this.bg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._more_assets_Background, this).setOrigin(0);

        this.introBag = new BackpackLayers(this, 0, 0);
        this.displayLayer = this.add.container();
        this.displayLayer.add(this.introBag);

        this.displayLayer.x = (this.scale.width / 2) - (this.introBag.fullBackpackCanvasImage.width / 2);
        this.displayLayer.y = 240;
        this.displayLayer.destY = this.displayLayer.y;

        this.title1 = ABCyaPhaser.Text.addText(this.scale.width/2, 62, 100, 0x871755, FontKeys._lemon_milkregular, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.make_a"), this, true).setStroke("#ffffff", 5).setShadow(0, 4, "#00000060", 0, true, false).setResolution(1.5).setPadding(5,5);
        
        this.title2 = ABCyaPhaser.Text.addCurvedText(this.scale.width/2, 200, 175, 0x871755, FontKeys._ostrich_sansheavy, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.backpack"), 650, this, -90*Phaser.Math.DEG_TO_RAD, 1.1, true, true)
        this.title2.y = this.title1.y + this.title1.displayHeight + this.title2.radius - 35;
        this.title2.letterTextFields.forEach(letter => letter.setStroke("#ffffff", 10).setShadow(0, 4, "#00000060", 0, true, false).setResolution(1.5));

        if(ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.backpack")=== "BACKPACK"){
          // adjust the P a bit
          this.title2.letterTextFields[4].x += 10;
          this.title2.letterTextFields[4].y += 5;
        }

        this.title1.destY = this.title1.y;
        this.title2.destY = this.title2.y;

        this.btnStart = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height - 80, UIAssetKeys._more_assets_BTN_Play, this).setInteractive();
        this.btnStart.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickNext, this);

        this.dyeData = gameData.menu[1].data;

        var ci = { outline: '#000000', light: '#d3d3d3', dark: '#bcbaba', gradient: ['#3a3738', '#817e7f'], handle: ['#000000', '#d3d3d3'] };
        this.introBag.fillColor(ci, 'gradient');

        this.beginIntro();
    }

    beginIntro()
    {
        ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._title, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        this.title1.y -= 300;
        this.title2.y = this.scale.height + this.title2.radius;
        this.title2.alpha = 0;

        this.displayLayer.y -= 1000;

        this.btnStart.setScale(0);

        let tweenTime = 1000;

        this.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(this.title1, tweenTime, { y: this.title1.destY }, Phaser.Math.Easing.Quadratic.Out),
                    ABCyaPhaser.Tweens.createTween(this.title2, tweenTime, { y: this.title2.destY, alpha: 1, offset: 0 }, Phaser.Math.Easing.Quadratic.Out),
                    ABCyaPhaser.Tweens.createTween(this.displayLayer, tweenTime, { y: this.displayLayer.destY, offset: tweenTime }, Phaser.Math.Easing.Quadratic.Out),
                    ABCyaPhaser.Tweens.createTween(this.btnStart, 640, { scale: 1, offset: tweenTime * 2, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out),
                ]
        });
        this.time.delayedCall(tweenTime, this.dyeRandom, null, this);
    }

    dyeRandom()
    {
        let fillcount = this.dyeData.fillTypes.length;
        let colorcount = this.dyeData.colors.length;
        let whichFill = Phaser.Math.Between(0, fillcount - 1);
        let whichColor = Phaser.Math.Between(0, colorcount - 1);

        let fillType = this.dyeData.fillTypes[whichFill];
        let colors = this.dyeData.colorValues[this.dyeData.colors[whichColor]];

        this.introBag.fillColor(colors, fillType);

        if (Phaser.Math.Between(0, 100) > 80)
        {
            let index = Phaser.Math.Between(0, gameData.menu[2].data.length - 1);
            this.introBag.drawPattern(index, "game-assets/PATTERN+" + (index + 1));
        } 

        this.time.delayedCall(900, this.dyeRandom, null, this);
    }

    onClickNext()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this);

        this.time.removeAllEvents();

        this.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(this.btnStart, 440, { scale: 1.1, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out),
                    ABCyaPhaser.Tweens.createTween([this.title1, this.title2, this.displayLayer], 1140, { alpha: 0, offset: 0 }, Phaser.Math.Easing.Quadratic.Out),
                    ABCyaPhaser.Tweens.createTween(this.bg, 1140, { alpha: 0, offset: 440 }, Phaser.Math.Easing.Quadratic.Out),
                ],
                onComplete: ()=> this.scene.start(MakeScene.KEY)
        });
    }
}